<template>
  <div>
    <div class="column is-12">
      <h2 class="title">¿Ya eres cliente nuestro?</h2>
    </div>
    <div class="column is-12">
      <option-select :options="stepOptions" @select="onSelect"/>
    </div>
  </div>
</template>

<script>
const options = [
  {
    label: 'Sí',
    value: true,
    component: 'ExistingCustomerFlow'
  },
  {
    label: 'No',
    value: false,
    component: 'NewCustomerFlow'
  }
];

export default {
  name: 'IsCustomerAlready',
  computed: {
    stepOptions() {
      return options;
    }
  },
  methods: {
    onSelect(option) {
      this.$emit('done', {
        key: 'isCustomerAlready',
        selectedOption: option
      });
    },
  }
}
</script>
